(function () {
  function isWishlistPage() {
    return window.location.pathname.indexOf('/apps/wishlist') === 0;
  }

  function formatModelTitle(rawTitle) {
    var raw = String(rawTitle || '').trim();
    if (!raw) return '';

    var mainPart = raw.split(' - ')[0].trim();
    var parts = mainPart.split(/\s+/).filter(Boolean);
    var firstWord = (parts[0] || '').toLowerCase().trim();
    var modelPart = '';

    if (firstWord === 'aldo' && parts.length > 1) modelPart = parts[1];
    else modelPart = parts[0] || '';

    if (!modelPart) modelPart = raw;

    var hyphenParts = modelPart.split('-');
    var formatted = hyphenParts
      .map(function (p) {
        var s = p.trim().toLowerCase();
        return s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
      })
      .filter(Boolean)
      .join('-');

    return formatted || modelPart;
  }

  function formatAnchorTitle(anchor) {
    if (!anchor) return;
    var href = anchor.getAttribute('href') || '';
    if (!/\/products\//.test(href)) return;
    if (anchor.dataset.aldoTitleFormatted === '1') return;

    var raw = (anchor.textContent || '').trim();
    if (!raw) return;

    var formatted = formatModelTitle(raw);
    if (!formatted) return;

    anchor.textContent = formatted;
    anchor.dataset.aldoTitleFormatted = '1';
  }

  function formatWishlistTitles() {
    try {
      var scope =
        document.querySelector('#wishlist-page-contain') ||
        document.querySelector('.wishlist-container') ||
        document;

      var anchors = scope.querySelectorAll('a[href*="/products/"]');
      anchors.forEach(formatAnchorTitle);
    } catch (e) {
      // no-op: never block wishlist page
    }
  }

  if (!isWishlistPage()) return;

  document.addEventListener('DOMContentLoaded', function () {
    formatWishlistTitles();

    var target =
      document.querySelector('#wishlist-page-contain') ||
      document.querySelector('.wishlist-container') ||
      document.body;

    if (!target) return;

    var observer = new MutationObserver(function () {
      formatWishlistTitles();
    });
    observer.observe(target, { childList: true, subtree: true });
  });
})();
